<template>
  <nuxt />
</template>
<script>
export default {
  middleware: ['redirect_after_login', 'auth'],
}
</script>
